module.exports = __webpack_public_path__ + "img/slide3.f453cae0.webp";